<template>
  <div class="ud">
    <div class="ud-card">
      <img src="/new-logo.png" class="ud-logo" alt="Maths Eleven Plus">
      <p class="ud-eyebrow">Maths Eleven Plus</p>
      <h1 class="ud-h1">We're putting the finishing touches on things.</h1>
      <p class="ud-p">
        The site is currently under development and not yet available.
        Please check back soon.
      </p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { usePageMeta } from '@/composables/usePageMeta';

onMounted(() => {
  usePageMeta({
    title: 'Maths Eleven Plus — Under Development',
    description: 'Maths Eleven Plus is currently under development. Please check back soon.',
    canonical: 'https://mathselevenplus.co.uk/',
  });
});
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,500;1,600&family=Jost:wght@300;400;500;600;700&display=swap');

.ud {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0D1628;
  font-family: 'Jost', sans-serif;
  padding: 24px;
}
.ud-card {
  max-width: 560px;
  text-align: center;
}
.ud-logo {
  width: 56px;
  height: 56px;
  margin-bottom: 20px;
}
.ud-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #B8902A;
  margin-bottom: 18px;
}
.ud-h1 {
  font-family: 'Cormorant Garamond', serif;
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.25;
  margin-bottom: 18px;
}
.ud-p {
  font-size: 16px;
  color: rgba(255,255,255,0.7);
  line-height: 1.7;
  font-weight: 400;
}

@media (max-width: 600px) {
  .ud-h1 { font-size: 30px; }
}
</style>
